
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecb1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecb1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("1is5Y", function(module, exports) {

$parcel$export(module.exports, "state", () => state);
$parcel$export(module.exports, "loadRecipe", () => loadRecipe);
$parcel$export(module.exports, "uploadRecipe", () => uploadRecipe);
$parcel$export(module.exports, "addBookmark", () => addBookmark);
$parcel$export(module.exports, "deleteRecipe", () => deleteRecipe);
$parcel$export(module.exports, "removeBookmark", () => removeBookmark);
$parcel$export(module.exports, "loadSearchResult", () => loadSearchResult);
$parcel$export(module.exports, "autocomplete", () => autocomplete);
$parcel$export(module.exports, "getSearchResultsByPage", () => getSearchResultsByPage);
$parcel$export(module.exports, "updateServings", () => updateServings);
$parcel$export(module.exports, "getLocalStorageBookmark", () => getLocalStorageBookmark);

var $fZ5A9 = parcelRequire("fZ5A9");

var $2yNoC = parcelRequire("2yNoC");
const state = {
    recipe: {},
    search: {
        keyword: "",
        result: [],
        page: 1
    },
    bookmarks: [],
    autocomplete: []
};
const setStateRecipe = function(datas) {
    const { recipe } = datas.data;
    return {
        cooking_time: recipe.cooking_time,
        id: recipe.id,
        image_url: recipe.image_url,
        ingredients: recipe.ingredients,
        publisher: recipe.publisher,
        servings: recipe.servings,
        source_url: recipe.source_url,
        title: recipe.title,
        bookmarked: false,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const loadRecipe = async function(id) {
    try {
        const datas = await (0, $2yNoC.getAJAX)(`${(0, $fZ5A9.API_URL)}${id}?key=${(0, $fZ5A9.API_KEY)}`);
        state.recipe = setStateRecipe(datas);
        /*  console.log(`loadRecipe`, state.recipe); */ // Set bookmarked.
        if (state.bookmarks.some((entry)=>entry.id === state.recipe.id)) state.recipe.bookmarked = true;
    } catch (error) {
        //TODO : refine output
        throw new Error(error.message);
    }
};
const uploadRecipe = async function(datas) {
    try {
        const recipeObj = {
            cooking_time: +datas.cookingTime,
            image_url: datas.image,
            ingredients: datas.ingredients,
            publisher: datas.publisher,
            servings: +datas.servings,
            source_url: datas.sourceUrl,
            title: datas.title
        };
        const response = await (0, $2yNoC.getAJAX)(`${(0, $fZ5A9.API_URL)}?key=${(0, $fZ5A9.API_KEY)}`, recipeObj);
        state.recipe = setStateRecipe(response);
        state.recipe.bookmarked = true;
        addBookmark(state.recipe);
    } catch (error) {
        throw new Error(error);
    }
};
const deleteRecipe = async function(id) {
    try {
        const response = await (0, $2yNoC.deleteAJAX)(`${(0, $fZ5A9.API_URL)}${id}?key=${(0, $fZ5A9.API_KEY)}`);
        // Remove from bookmarks
        removeBookmark(id);
        setLocalStorageBookmark();
        // Remove recipe from search results
        const index = state.search.result.findIndex((el)=>el.id == id);
        if (Number.isFinite(index)) state.search.result.splice(index, 1);
    } catch (error) {
        throw new Error(error);
    }
};
const loadSearchResult = async function(query) {
    try {
        const results = await (0, $2yNoC.getAJAX)(`${(0, $fZ5A9.API_URL)}?search=${query}&key=${(0, $fZ5A9.API_KEY)}`);
        // Use to render the search result header.
        state.search.keyword = query;
        const { recipes } = results.data;
        state.search.result = recipes;
    } catch (error) {
        //TODO : refine output
        throw new Error(error.message);
    }
};
const autocomplete = function(word) {
    state.autocomplete = [];
    if (word === "") return;
    const searchTerms = [
        ...(0, $fZ5A9.API_SEARCH_TERMS)
    ].sort();
    const terms = searchTerms.filter((term)=>term.startsWith(word));
    if (terms.length === 0) return;
    state.autocomplete = terms;
};
const getSearchResultsByPage = function(page = this.state.search.page) {
    // Update page number.
    state.search.page = page;
    const start = (page - 1) * (0, $fZ5A9.RESULTS_BY_PAGE);
    const end = page * (0, $fZ5A9.RESULTS_BY_PAGE);
    return state.search.result.slice(start, end);
};
const updateServings = function(nbServings) {
    state.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * nbServings / state.recipe.servings;
    });
    state.recipe.servings = nbServings;
};
const addBookmark = function(recipe) {
    if (state.recipe.id === recipe.id) state.recipe.bookmarked = true;
    const isDupplicate = state.bookmarks.some((el)=>el.id == recipe.id);
    if (isDupplicate) return;
    state.bookmarks.push(state.recipe);
    setLocalStorageBookmark();
    console.log(`/// addBookmark /// =>`, recipe);
};
const removeBookmark = function(id) {
    const index = state.bookmarks.findIndex((el)=>el.id === id);
    state.bookmarks.splice(index, 1);
    if (state.recipe.id === id) state.recipe.bookmarked = false;
    setLocalStorageBookmark();
};
const setLocalStorageBookmark = function() {
    localStorage.setItem("bookmarks", JSON.stringify(state.bookmarks));
};
const getLocalStorageBookmark = function() {
    const bookmarks = localStorage.getItem("bookmarks");
    if (bookmarks) state.bookmarks = JSON.parse(bookmarks);
};

});
parcelRegister("fZ5A9", function(module, exports) {

$parcel$export(module.exports, "API_URL", () => $ba30e20475feac5a$export$923ea8233b386e99);
$parcel$export(module.exports, "API_KEY", () => $ba30e20475feac5a$export$a9861bd62f48e142);
$parcel$export(module.exports, "RESULTS_BY_PAGE", () => $ba30e20475feac5a$export$894cfd1672a05f4a);
$parcel$export(module.exports, "API_SEARCH_TERMS", () => $ba30e20475feac5a$export$6b3e8d490c3d76a2);
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $ba30e20475feac5a$export$a9861bd62f48e142 = `502d3112-5c26-4088-aa38-29921bcbcdc6`;
const $ba30e20475feac5a$export$894cfd1672a05f4a = 10;
const $ba30e20475feac5a$export$50cfafdd5d2908b3 = ".recipe";
const $ba30e20475feac5a$export$6b3e8d490c3d76a2 = new Set([
    "carrot",
    "broccoli",
    "asparagus",
    "cauliflower",
    "corn",
    "cucumber",
    "green pepper",
    "lettuce",
    "mushrooms",
    "onion",
    "potato",
    "pumpkin",
    "red pepper",
    "tomato",
    "beetroot",
    "brussel sprouts",
    "peas",
    "zucchini",
    "radish",
    "sweet potato",
    "artichoke",
    "leek",
    "cabbage",
    "celery",
    "chili",
    "garlic",
    "basil",
    "coriander",
    "parsley",
    "dill",
    "rosemary",
    "oregano",
    "cinnamon",
    "saffron",
    "green bean",
    "bean",
    "chickpea",
    "lentil",
    "apple",
    "apricot",
    "avocado",
    "banana",
    "blackberry",
    "blackcurrant",
    "blueberry",
    "boysenberry",
    "cherry",
    "coconut",
    "fig",
    "grape",
    "grapefruit",
    "kiwifruit",
    "lemon",
    "lime",
    "lychee",
    "mandarin",
    "mango",
    "melon",
    "nectarine",
    "orange",
    "papaya",
    "passion fruit",
    "peach",
    "pear",
    "pineapple",
    "plum",
    "pomegranate",
    "quince",
    "raspberry",
    "strawberry",
    "watermelon",
    "salad",
    "pizza",
    "pasta",
    "popcorn",
    "lobster",
    "steak",
    "bbq",
    "pudding",
    "hamburger",
    "pie",
    "cake",
    "sausage",
    "tacos",
    "kebab",
    "poutine",
    "seafood",
    "chips",
    "fries",
    "masala",
    "paella",
    "som tam",
    "chicken",
    "toast",
    "marzipan",
    "tofu",
    "ketchup",
    "hummus",
    "chili",
    "maple syrup",
    "parma ham",
    "fajitas",
    "champ",
    "lasagna",
    "poke",
    "chocolate",
    "croissant",
    "arepas",
    "bunny chow",
    "pierogi",
    "donuts",
    "rendang",
    "sushi",
    "ice cream",
    "duck",
    "curry",
    "beef",
    "goat",
    "lamb",
    "turkey",
    "pork",
    "fish",
    "crab",
    "bacon",
    "ham",
    "pepperoni",
    "salami",
    "ribs",
    "eggplant"
]);

});

parcelRegister("2yNoC", function(module, exports) {

$parcel$export(module.exports, "getAJAX", () => $1dd512cbb048c74b$export$77a72e302cf027c9);
$parcel$export(module.exports, "deleteAJAX", () => $1dd512cbb048c74b$export$22a59f3d99ffbefd);
/**
 * Reject ajax after x seconds
 * @param {number}
 * @returns {Promise}
 */ const $1dd512cbb048c74b$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $1dd512cbb048c74b$export$77a72e302cf027c9 = async function(url, obj) {
    try {
        const f = obj ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj)
        }) : fetch(url);
        const response = await Promise.race([
            f,
            $1dd512cbb048c74b$var$timeout(2)
        ]);
        if (!response.ok) throw new Error(`${response.status}`);
        const datas = await response.json();
        return datas;
    } catch (error) {
        throw error;
    }
};
const $1dd512cbb048c74b$export$22a59f3d99ffbefd = async function(url) {
    try {
        const f = fetch(url, {
            method: "DELETE"
        });
        const response = await Promise.race([
            f,
            $1dd512cbb048c74b$var$timeout(2)
        ]);
        if (!response.ok) throw new Error(`${response.status}`);
        return response;
    } catch (error) {
        throw error;
    }
};

});


var $f98cebd3e0831e94$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["f9fpV","index.fd6c01c4.js","eyyUD","icons.1db7bc1e.svg"]'));

var $77b629c0b49e8bca$exports = {};
$77b629c0b49e8bca$exports = new URL("icons.1db7bc1e.svg", import.meta.url).toString();



class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    _datas = {};
    _successMess = "";
    _errorMess = "Not the right format!";
    constructor(parentElement = ""){
        this._parentElement = document.querySelector(parentElement);
    }
    render(datas) {
        // Guard.
        if (!datas || Array.isArray(datas) && datas.length === 0) return this.renderError();
        this._datas = datas;
        this._clear();
        this._insertMarkup(this._renderMarkup());
    }
    /**
   *
   * @param {*} datas
   */ update(datas) {
        this._datas = datas;
        const newMarkup = this._renderMarkup();
        // New markup in memory.
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newEls = Array.from(newDOM.querySelectorAll("*"));
        const currEls = Array.from(this._parentElement.querySelectorAll("*"));
        newEls.forEach(function(newEl, i) {
            const currEl = currEls[i];
            if (!newEl.isEqualNode(currEl)) {
                if (newEl.firstChild?.nodeValue.trim() !== "") currEl.textContent = newEl.textContent;
                // See data-xx attributes.
                Array.from(newEl.attributes).forEach((att)=>currEl.setAttribute(att.name, att.value));
            }
        });
    }
    renderSuccess(success = this._successMess) {
        const markup = ` <div class="error">
    <div>
        <svg><use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-smile"></use></svg>
      </div>
      <p>${success}</p>
    </div>`;
        this._clear();
        this._insertMarkup(markup);
    }
    /**
   * Insert error message markup in the dedicated (this._parentElement) DOM container.
   * @param {string} error message.
   */ renderError(error = this._errorMess) {
        const markup = ` <div class="error">
    <div>
        <svg><use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-alert-triangle"></use></svg>
      </div>
      <p>${error}</p>
    </div>`;
        this._clear();
        this._insertMarkup(markup);
    }
    /**
   * Insert spinner markup in the dedicated (this._parentElement) DOM container.
   */ renderSpinner() {
        const markup = `<div class="spinner">
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-loader"></use>
    </svg>
  </div>`;
        this._clear();
        this._insertMarkup(markup);
    }
    /**
   * Remove markup in the dedicated (this._parentElement) DOM container.
   * @return {string} Empty string.
   */ _clear() {
        this._parentElement.innerHTML = "";
    }
    /**
   * Insert markup in the dedicated (this._parentElement) DOM container.
   * @param {string} markup
   */ _insertMarkup(markup = ``) {
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}


var $af517d3060c307fe$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$af517d3060c307fe$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = "-";
    } else type = "";
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return "0";
    const numberString = number.toString();
    const entry = numberString.split(".");
    let integer = entry[0];
    let decimal;
    if (decimal == "0" && integer !== "0") return integer;
    else if (decimal == "0" && integer == "0") return "0";
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == "99" && integer !== "0") return `${integer} 99/100`;
    else if (decimal == "99" && integer == "0") return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = "999";
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split("").reverse().join(""); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split("").reverse().join("");
        let endPattern = pattern[1].split("").reverse().join("");
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split("");
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $af517d3060c307fe$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $af517d3060c307fe$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $af517d3060c307fe$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $af517d3060c307fe$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $af517d3060c307fe$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $af517d3060c307fe$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == "0") return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


/**
 * Recipe section markup & events.
 * @extends View
 */ class $d14dc0f178617192$var$RecipeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    //// HANDLERS ////
    /**
   *
   * @param {*} handler
   */ handlerRenderRecipe(handler) {
        [
            "load",
            "hashchange"
        ].forEach((evt)=>window.addEventListener(evt, handler));
    }
    handlerDeleteRecipe(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btnDeleteRecipe = e.target.closest(".btn--delete-recipe");
            if (btnDeleteRecipe) handler();
        });
    }
    handlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btnUpdateServings = e.target.closest(".btn--update-servings");
            if (!btnUpdateServings) return;
            const { updateServings: updateServings } = btnUpdateServings.dataset;
            if (+updateServings > 0) handler(+updateServings);
        });
    }
    //// MARKUP ////
    /**
   *
   * @returns
   */ _renderMarkup() {
        return `${this._renderRecipeImage()}
    ${this._renderRecipeNavigation()}
    <div class="recipe__ingredients">
      <h2 class="heading--2">Recipe ingredients</h2>
      <ul class="recipe__ingredient-list">
       ${this._datas.ingredients.map((ing)=>this._renderIngredients(ing)).join("")}
      </ul>
    </div>
    ${this._renderRecipeFooter()}
`;
    }
    _renderRecipeImage() {
        return `<figure class="recipe__fig">
    <img src="${this._datas.image_url}" alt="${this._datas.title}" class="recipe__img" />
    <h1 class="recipe__title">
      <span>${this._datas.title}</span>
    </h1>
  </figure>`;
    }
    _renderRecipeNavigation() {
        return ` <div class="recipe__details">
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-clock"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--minutes">${this._datas.cooking_time}</span>
      <span class="recipe__info-text">minutes</span>
    </div>
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-users"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--people">${this._datas.servings}</span>
      <span class="recipe__info-text">servings</span>
      <div class="recipe__info-buttons">
        <button class="btn--tiny btn--update-servings" data-update-servings="${this._datas.servings - 1}">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-minus-circle"></use>
          </svg>
        </button>
        <button class="btn--tiny btn--update-servings" data-update-servings="${this._datas.servings + 1}">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-plus-circle"></use>
          </svg>
        </button>
      </div>
    </div>
    
    <button class="btn--round btn--bookmark">
      <svg class="">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-bookmark${this._datas.bookmarked ? "-fill" : ""}"></use>
      </svg>
    </button>
    ${this._datas.key ? `<button class="btn--round btn--delete-recipe">
       <svg><use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-delete"></use></svg>
     </button>` : ""}
  </div>`;
    }
    _renderIngredients(ing) {
        return `<li class="recipe__ingredient">
    <svg class="recipe__icon">
      <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-check"></use>
    </svg>
   ${this._renderQuantity(ing.quantity)}
    <div class="recipe__description">
      <span class="recipe__unit">${ing.unit}</span>
      <span>${ing.description}</span>
    </div>
  </li>`;
    }
    _renderRecipeFooter() {
        return `<div class="recipe__directions">
    <h2 class="heading--2">How to cook it</h2>
    <p class="recipe__directions-text">
      This recipe was carefully designed and tested by
      <span class="recipe__publisher">${this._datas.publisher}</span>. Please check out
      directions at their website.
    </p>
    <a
      class="btn--small recipe__btn"
      href="${this._datas.source_url}"
      target="_blank"
    >
      <span>Directions</span>
      <svg class="search__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-right"></use>
      </svg>
    </a>
  </div>`;
    }
    _renderQuantity(quantity) {
        if (quantity > 0) return `<div class="recipe__quantity">${(0, (/*@__PURE__*/$parcel$interopDefault($af517d3060c307fe$exports)))(quantity)}</div>`;
        return "";
    }
}
var $d14dc0f178617192$export$2e2bcd8739ae039 = new $d14dc0f178617192$var$RecipeView(".recipe");



/**
 * Add Recipe form section markup & events.
 * @extends View
 */ class $e5dc5dc5ede8bdf4$var$AddRecipeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _errorMess = "Couille dans le potage";
    _successMess = "Recipe added !";
    _addRecipeWindow = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _fieldsets;
    _ingredient = {
        index: 1
    };
    //// HANDLERS ////
    toogleWindow() {
        this._addRecipeWindow.classList.toggle("hidden");
        this._overlay.classList.toggle("hidden");
    }
    _addIngredient() {
        this._ingredient.index++;
        document.querySelector(".upload__column--right").insertAdjacentHTML("beforeend", this._renderIngredientMarkup());
    }
    /**
   *
   * @param {*} handler
   */ handlerToggleRecipeForm() {
        // Nav btn
        document.querySelector(".nav__btn--add-recipe").addEventListener("click", this.toogleWindow.bind(this));
        // Close btn
        document.querySelector(".btn--close-modal").addEventListener("click", this.toogleWindow.bind(this));
        // Overlay
        document.querySelector(".overlay").addEventListener("click", this.toogleWindow.bind(this));
    }
    handleraddIngredient() {
        document.querySelector(".btn--add-ingredient").addEventListener("click", this._addIngredient.bind(this));
    }
    handlerUploadRecipe(handler) {
        const that = this;
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            // Convert to array.
            let formDatas = [
                ...new FormData(this)
            ];
            that._fieldsets = this.querySelectorAll("fieldset.upload__ingredient");
            // Remove ingredients from formDatas.
            const noIngForm = formDatas.filter((el)=>!el[0].startsWith(`ingredient`));
            // Array to Object and add ingredients.
            const datas = Object.fromEntries(noIngForm);
            const ingredients = that._getIngredients(formDatas);
            if (ingredients) {
                datas.ingredients = ingredients;
                handler(datas);
            }
        });
    }
    _getIngredients(formDatas) {
        const ingredients = [];
        let isOk = true;
        let nbIngredients = this._fieldsets.length;
        // Group ingredients.
        while(nbIngredients > 0){
            const ing = formDatas.filter((el)=>el[0].startsWith(`ingredient-${nbIngredients}`)).map((el)=>{
                const term = el[0].split("-");
                el[0] = term[2];
                return el;
            });
            ingredients.push(Object.fromEntries(ing));
            nbIngredients--;
        }
        // Check format.
        ingredients.forEach((entry, index)=>{
            const { quantity: quantity } = entry;
            if (isNaN(quantity)) {
                isOk = false;
                this._fieldsets[index].insertAdjacentHTML("beforeend", `<p class="upload__error"><strong>${quantity}</strong>: Quantity must be a number! </p>`);
            }
        });
        if (!isOk) return;
        return ingredients;
    }
    //// DOM ////
    _renderIngredientMarkup() {
        return `<fieldset class="upload__ingredient" data-index="${this._ingredient.index}">
    <legend>Ingredient ${this._ingredient.index}</legend>
    <div class="upload__ingredient-container">
    <div>
      <label for="ingredient-${this._ingredient.index}-quantity">Quantity</label>
    <input
      value="0.5"
      type="text"
      name="ingredient-${this._ingredient.index}-quantity"
      id="ingredient-${this._ingredient.index}-quantity"
      placeholder="Quantity"
      size="5"
    /></div>
    <div>
      <label for="ingredient-${this._ingredient.index}-unit">Unit</label>
    <input
      value="kg"
      type="text"
      name="ingredient-${this._ingredient.index}-unit"
      id="ingredient-${this._ingredient.index}-unit"
      placeholder="unit: e.g. kg, spoon..."
      size="5"
    />
  </div>
    <div><label for="ingredient-${this._ingredient.index}-description">Description</label>
    <input
      value="0.5"
      type="text"
      required
      name="ingredient-${this._ingredient.index}-description"
      id="ingredient-${this._ingredient.index}-description"
      placeholder="Description"
    />
  </div>
</div>
  </fieldset>`;
    }
}
var $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039 = new $e5dc5dc5ede8bdf4$var$AddRecipeView(".upload");


/**
 * @description Search Recipe event handlers & query parsing.
 * @class
 */ class $813cf99795e9ec97$var$SearchView {
    _parentElement = document.querySelector(".search__container");
    _input = this._parentElement.querySelector("input.search__field");
    _autocomplete = this._parentElement.querySelector(".autocomplete");
    handlerSearchRecipe(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            handler();
        });
    }
    handlerSearchRecipeAutocomplete(handler) {
        this._parentElement.addEventListener("input", function(e) {
            const word = e.target.value;
            if (word.length > 3) return;
            handler(word);
        });
    }
    setQuery(word) {
        this._input.value = word;
    }
    query() {
        const query = this._input.value;
        this._input.value = "";
        return query;
    }
}
var $813cf99795e9ec97$export$2e2bcd8739ae039 = new $813cf99795e9ec97$var$SearchView();



/**
 * Search recipe Autocomplete section markup & events.
 * @extends View
 */ class $e991ed56cd29ee30$var$AutocompleteView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    //// HANDLER ////
    handlerSelectTerm(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const word = e.target.textContent;
            handler(word);
        });
    }
    handlerClearTerms(handler) {
        document.addEventListener("click", function(e) {
            const element = e.target.closest(".autocomplete");
            if (!element) handler();
        });
    }
    //// MARKUP ////
    /**
   *
   * @returns
   */ _renderMarkup() {
        return this._datas.map((term)=>this._renderTerm(term)).join("");
    }
    _renderTerm(term) {
        return `<div class="autocomplete__term">
    <p><strong class="">${term[0].toUpperCase()}</strong>${term.slice(1)}</p>
    </div>`;
    }
}
var $e991ed56cd29ee30$export$2e2bcd8739ae039 = new $e991ed56cd29ee30$var$AutocompleteView(".autocomplete");





/**
 * Recipe search results header section markup.
 * @extends View
 */ class $cdd67666958b2c61$var$SearchResultHeaderView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    //// MARKUP ////
    /**
   * Render Recipe search result title.
   * @returns {string} - Markup
   */ _renderMarkup() {
        return ` 
    <h2 class="heading--2">${this._datas.result.length} ${this._datas.keyword}'s recipes</h2>
    `;
    }
}
var $cdd67666958b2c61$export$2e2bcd8739ae039 = new $cdd67666958b2c61$var$SearchResultHeaderView(".search-results__header");





var $fZ5A9 = parcelRequire("fZ5A9");
/**
 * Recipe search result pagination section markup & events.
 * @extends View
 */ class $cfa940594ee109f7$var$PaginationView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _numPage;
    _currentPage;
    //// HANDLER ////
    handlerPagination(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const currBtn = e.target.closest(".pagination__btn");
            if (!currBtn) return;
            const { pageIndex: pageIndex } = currBtn.dataset;
            handler(+pageIndex);
        });
    }
    //// MARKUP ////
    _renderMarkup() {
        this._numPage = Math.ceil(this._datas.result.length / (0, $fZ5A9.RESULTS_BY_PAGE));
        this._currentPage = this._datas.page;
        // Page 1 and other pages.
        if (this._currentPage === 1 && this._numPage > 1) return `
      <button class="btn--inline pagination__btn pagination__btn--next" data-page-index ="${this._currentPage + 1}" >
        <span>Page ${this._currentPage + 1}</span>
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-right"></use>
        </svg>
      </button>
      ${this._renderBtnCenter()}`;
        // Last page
        if (this._currentPage === this._numPage) return `${this._renderBtnCenter()}
      <button class="btn--inline pagination__btn pagination__btn--prev"  data-page-index ="${this._currentPage - 1}">
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-left"></use>
        </svg>
        <span>Page ${this._currentPage - 1}</span>
      </button>`;
        return `<button class="btn--inline pagination__btn pagination__btn--prev" data-page-index ="${this._currentPage - 1}">
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-left"></use>
        </svg>
        <span>Page ${this._currentPage - 1}</span>
      </button>
      ${this._renderBtnCenter()}
      <button class="btn--inline pagination__btn pagination__btn--next"  data-page-index ="${this._currentPage + 1}">
        <span>Page ${this._currentPage + 1}</span>
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-right"></use>
        </svg>
      </button>`;
    }
    _renderBtnCenter() {
        return `<div class="pagination--center" >
        <span>Page ${this._currentPage}&#8239;/&#8239;${this._numPage}</span>
      </div>`;
    }
}
var $cfa940594ee109f7$export$2e2bcd8739ae039 = new $cfa940594ee109f7$var$PaginationView(".pagination");




/**
 * Recipe's ingredients section markup & events.
 */ class $ea75d8931902fda2$var$RecipeListItemView {
    _datas = undefined;
    /**
   *
   * @param {*} datas
   * @returns {string}
   */ renderRecipeListItem(datas) {
        const hash = location.hash.slice(1);
        this._datas = datas;
        return ` 
    <li class="preview">
      <a class="preview__link ${hash === datas.id ? `preview__link--active` : ``}" href="#${datas.id}">
        <figure class="preview__fig">
          <img src="${datas.image_url}" alt="${datas.title}" />
        </figure>
        <div class="preview__data">
          <h4 class="preview__title">${datas.title}</h4>
          <p class="preview__publisher">${datas.publisher}</p>
         ${this._renderUser(datas)}
        </div>
      </a>
    </li>
    `;
    }
    _renderUser(datas) {
        return datas.key ? `<div class="preview__user-generated">
        <svg><use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-user"></use></svg>
      </div>` : "";
    }
}
var $ea75d8931902fda2$export$2e2bcd8739ae039 = new $ea75d8931902fda2$var$RecipeListItemView();


/**
 * Add Recipe form section markup & events.
 * @extends View
 */ class $910f3788fadd217e$var$SearchResultView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    /**
   * Render Search result recipe items.
   * @returns {string} - Markup.
   */ _renderMarkup() {
        return this._datas.map((recipe)=>(0, $ea75d8931902fda2$export$2e2bcd8739ae039).renderRecipeListItem(recipe)).join("");
    }
}
var $910f3788fadd217e$export$2e2bcd8739ae039 = new $910f3788fadd217e$var$SearchResultView(".results");





/**
 * Recipe bookmarks section markup & events.
 * @extends View
 */ class $c5eab150e9f25972$var$BookmarkView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _bookmarkBtnContainer = document.querySelector(".recipe");
    _errorMess = "No bookmarks yet. Find a nice recipe and bookmark it :)";
    //// HANDLERS ///
    handlerAddBookmark(handler) {
        this._bookmarkBtnContainer.addEventListener("click", function(e) {
            e.preventDefault();
            const btn = e.target.closest(".btn--bookmark");
            if (!btn) return;
            handler();
        });
    }
    handlerBookmarksStorage(handler) {
        window.addEventListener("load", handler);
    }
    /// BOOKMARKS ///
    _renderMarkup() {
        // console.log(!Array.isArray(this._datas));
        return this._datas.map((recipe)=>(0, $ea75d8931902fda2$export$2e2bcd8739ae039).renderRecipeListItem(recipe)).join("");
    }
}
var $c5eab150e9f25972$export$2e2bcd8739ae039 = new $c5eab150e9f25972$var$BookmarkView(".bookmarks__list");



var $1is5Y = parcelRequire("1is5Y");
// Handlers
/**
 * Control the loading and render recipe item process.
 */ const $f50bd1f2915ed0f2$var$controlRenderRecipe = async function() {
    const id = location.hash.slice(1);
    if (!id) return;
    try {
        // Load recipe.
        await $1is5Y.loadRecipe(id);
        // Render recipe.
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($1is5Y.state.recipe);
        // Update Bookmarks && search results.
        if ($1is5Y.state.bookmarks.length !== 0) (0, $c5eab150e9f25972$export$2e2bcd8739ae039).render($1is5Y.state.bookmarks);
    } catch (error) {
        console.error(`controlRenderRecipe`, error);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderError(error);
    }
};
// Add recipe.
const $f50bd1f2915ed0f2$var$controlUploadRecipe = async function(datas) {
    try {
        await $1is5Y.uploadRecipe(datas);
        // Render success.
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderSuccess();
        // Update hash.
        window.history.pushState(null, "", `#${$1is5Y.state.recipe.id}`);
        // Render recipe.
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($1is5Y.state.recipe);
        // Update bookmarks.
        (0, $c5eab150e9f25972$export$2e2bcd8739ae039).render($1is5Y.state.bookmarks);
        // Close popup window
        setTimeout((0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).toogleWindow(), 20000);
    } catch (error) {
        console.log(`controlUploadRecipe Error =>`, error);
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderError(error);
    }
};
const $f50bd1f2915ed0f2$var$controlDeleteRecipe = async function() {
    try {
        await $1is5Y.deleteRecipe($1is5Y.state.recipe.id);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderSuccess(`${$1is5Y.state.recipe.title} has been deleted.`);
        // Update Bookmarks && search results.
        // TODO set update
        (0, $c5eab150e9f25972$export$2e2bcd8739ae039).render($1is5Y.state.bookmarks);
        if ($1is5Y.state.search.result.length !== 0) {
            // Render search results.
            (0, $910f3788fadd217e$export$2e2bcd8739ae039).render($1is5Y.getSearchResultsByPage());
            // Render pagination.
            (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($1is5Y.state.search);
            // Render search result Header.
            (0, $cdd67666958b2c61$export$2e2bcd8739ae039).render($1is5Y.state.search);
        }
        window.history.replaceState(null, "", location.origin);
        setTimeout(()=>(0, $d14dc0f178617192$export$2e2bcd8739ae039).renderSuccess("Start by searching for a recipe or an ingredient. Have fun!"), 1000);
    } catch (error) {
        console.error(`controlRenderRecipe`, error);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderError(error);
    }
};
/**
 *
 */ const $f50bd1f2915ed0f2$var$controlSearchRecipe = async function() {
    try {
        // Get query keyword
        const query = (0, $813cf99795e9ec97$export$2e2bcd8739ae039).query();
        if (!query) return;
        // Load search results.
        await $1is5Y.loadSearchResult(query);
        // Render search results.
        (0, $910f3788fadd217e$export$2e2bcd8739ae039).render($1is5Y.getSearchResultsByPage());
        // Render pagination.
        (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($1is5Y.state.search);
        // Render search result Header.
        (0, $cdd67666958b2c61$export$2e2bcd8739ae039).render($1is5Y.state.search);
    } catch (error) {}
};
/// Autocomplete. ///
const $f50bd1f2915ed0f2$var$controlSearchRecipeAutocomplete = function(word) {
    (0, $e991ed56cd29ee30$export$2e2bcd8739ae039)._clear();
    $1is5Y.autocomplete(word);
    if ($1is5Y.state.autocomplete.length > 0) (0, $e991ed56cd29ee30$export$2e2bcd8739ae039).render($1is5Y.state.autocomplete);
};
const $f50bd1f2915ed0f2$var$controlSelectTerm = function(word) {
    console.log(`controlSelectTerm`, word);
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).setQuery(word);
    (0, $e991ed56cd29ee30$export$2e2bcd8739ae039)._clear();
};
const $f50bd1f2915ed0f2$var$controlClearTerms = function() {
    (0, $e991ed56cd29ee30$export$2e2bcd8739ae039)._clear();
};
/// Pagination. ///
const $f50bd1f2915ed0f2$var$controlPagination = function(page) {
    $1is5Y.state.search.page = page;
    // Render search results.
    (0, $910f3788fadd217e$export$2e2bcd8739ae039).render($1is5Y.getSearchResultsByPage());
    // Render pagination.
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($1is5Y.state.search);
};
// Bookmarks.
const $f50bd1f2915ed0f2$var$controlAddRemoveBookmark = function() {
    $1is5Y.state.recipe.bookmarked ? $1is5Y.removeBookmark($1is5Y.state.recipe.id) : $1is5Y.addBookmark($1is5Y.state.recipe);
    (0, $c5eab150e9f25972$export$2e2bcd8739ae039).render($1is5Y.state.bookmarks);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update($1is5Y.state.recipe);
    (0, $910f3788fadd217e$export$2e2bcd8739ae039).update($1is5Y.getSearchResultsByPage());
};
const $f50bd1f2915ed0f2$var$controlBookmarksStorage = function() {
    if ($1is5Y.state.bookmarks.length !== 0) (0, $c5eab150e9f25972$export$2e2bcd8739ae039).render($1is5Y.state.bookmarks);
};
// Update servings.
const $f50bd1f2915ed0f2$var$controlUpdateServings = function(nbServings) {
    $1is5Y.updateServings(nbServings);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update($1is5Y.state.recipe);
};
// INIT //
(function() {
    // Add recipe.
    (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).handlerToggleRecipeForm();
    (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).handleraddIngredient();
    (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).handlerUploadRecipe($f50bd1f2915ed0f2$var$controlUploadRecipe);
    // Load recipe.
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).handlerRenderRecipe($f50bd1f2915ed0f2$var$controlRenderRecipe);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).handlerDeleteRecipe($f50bd1f2915ed0f2$var$controlDeleteRecipe);
    // Search recipe.
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).handlerSearchRecipe($f50bd1f2915ed0f2$var$controlSearchRecipe);
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).handlerSearchRecipeAutocomplete($f50bd1f2915ed0f2$var$controlSearchRecipeAutocomplete);
    (0, $e991ed56cd29ee30$export$2e2bcd8739ae039).handlerSelectTerm($f50bd1f2915ed0f2$var$controlSelectTerm);
    (0, $e991ed56cd29ee30$export$2e2bcd8739ae039).handlerClearTerms($f50bd1f2915ed0f2$var$controlClearTerms);
    // Pagination.
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).handlerPagination($f50bd1f2915ed0f2$var$controlPagination);
    // Bookmarks.
    $1is5Y.getLocalStorageBookmark();
    (0, $c5eab150e9f25972$export$2e2bcd8739ae039).handlerBookmarksStorage($f50bd1f2915ed0f2$var$controlBookmarksStorage);
    (0, $c5eab150e9f25972$export$2e2bcd8739ae039).handlerAddBookmark($f50bd1f2915ed0f2$var$controlAddRemoveBookmark);
    // Update servings.
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).handlerUpdateServings($f50bd1f2915ed0f2$var$controlUpdateServings);
})();


//# sourceMappingURL=index.fd6c01c4.js.map
